module.exports = __webpack_public_path__ + "static/media/magicalSound.87cc44da.mp3";